import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";

export default function getPointSymbol({
  markupPointColor,
  markupPointSize,
  markupPointStyle,
  markupPointOutlineColor,
  markupPointOutlineWidth,
  markupPointOutlineStyle,
}) {
  const pointSymbol = new SimpleMarkerSymbol({
    color: markupPointColor,
    size: markupPointSize,
    style: markupPointStyle,
    outline: {
      color: markupPointOutlineColor,
      width: markupPointOutlineWidth,
      style: markupPointOutlineStyle || "solid",
    },
  });
  return pointSymbol;
}
